import { CompListCore } from '../core/list/comp'

export const CompList = CompListCore
